// ----------------------------------------------------------------------
// <copyright file="Izenda.GroupHeaderCell.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import AppGlobal from 'Izenda.AppGlobal';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';

!(function() {
  var React = require('react');
  var observer = require('mobx-react').observer;
  const { isString, isFunction } = require('lodash/fp');
  var GroupHeaderCell = observer(
    React.createClass({
      render: function() {
        var props = this.props;
        if (isFunction(this.props.renderTitle)) {
          var headerTitle = this.props.renderTitle(this.props.didUpdate);
          var title = isString(headerTitle) ? headerTitle : null;
          var infoIconOptions = props.infoIconOptions;
          if(AppGlobal.isRenderHtmlInReportViewer() && isString(headerTitle)){
            headerTitle = (<span dangerouslySetInnerHTML={{__html: headerTitle}}></span>);
            title = ReportPartUtils.getTextContentFromHtmlString(title);
          }
          return (
            <span title={title}>
              {headerTitle || ' '}
              {infoIconOptions && <span className={infoIconOptions.iconClass} title={infoIconOptions.iconTitle} />}
            </span>
          );
        }
        return null;
      },
      componentDidMount: function() {
        this.props.didUpdate && this.props.didUpdate();
      },
      componentDidUpdate: function() {
        this.props.didUpdate && this.props.didUpdate();
      }
    })
  );

  module.exports = GroupHeaderCell;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/Izenda.GroupHeaderCell.jsx